import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import configureStore from "../store/store";
import { logoutUser } from "../store/actions/actions";

const superagent = superagentPromise(_superagent, Promise);

const responseBody = (res) => res.body;
const apiUrl = window.__ENV && window.__ENV.apiUrl;
// const apiUrl = window.__ENV && window.__ENV.apiUrl;//eslint-disable-next-line
const OAuth_apiUrl = window.__ENV && window.__ENV.OAuth_apiUrl;//eslint-disable-next-line
const grant_type = window.__ENV && window.__ENV.grant_type;//eslint-disable-next-line
const redirect_uri = window.__ENV && window.__ENV.redirect_uri;//eslint-disable-next-line
const client_id = window.__ENV && window.__ENV.client_id;//eslint-disable-next-line
const client_secret = window.__ENV && window.__ENV.client_secret;

const handleErrors = (err) => {
  if (err && err.status === 401) {
    const store = configureStore();
    store.dispatch(logoutUser("Unauthorized/TokenExpired"));
  }
};

const requests = {
  post: (url, body) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/json")
      .on("error", handleErrors)
      .then(responseBody),
  postData: (url, body) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/x-www-form-urlencoded")
      .on("error", handleErrors)
      .then(responseBody),
  postWithoutToken: (url) =>
    superagent
      .post(url)
      // .set('Content-Type', 'application/json')
      // .set('Authorization', `Bearer ${token}`)
      .on('error', handleErrors)
      .then(responseBody),
  getWithToken: (url, token) =>
    superagent
      .get(url)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  postWithToken: (url, body, token) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  deleteWithToken: (url, token) =>
    superagent
      .del(url, token)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  putWithToken: (url, body, token) =>
    superagent
      .put(url, body, token)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  uploadWithToken: (url, data, token) =>
    superagent
      .post(url, data)
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
};

const Auth = {
  login: (code: string) => {
    const formData = { //eslint-disable-next-line
      "grant_type": grant_type,
      "code": code,//eslint-disable-next-line
      "redirect_uri": redirect_uri,//eslint-disable-next-line
      "client_id": client_id,//eslint-disable-next-line
      "client_secret": client_secret,
    };

    return requests.postData(`${OAuth_apiUrl}/token`, formData);
  },

  getRefreshToken: (refreshToken) => {
    return requests.postWithoutToken(`${OAuth_apiUrl}/token?grant_type=refresh_token&client_id=${client_id}&client_secret=${client_secret}&refresh_token=${refreshToken}`);
  },

  getCurrentUser: (access_token: string) => {
    return requests.getWithToken(`${apiUrl}/api/user/profile`, access_token);
  },
  enableAccount: (data: any, code) => {
    const { password, confirmPassword } = data;
    return requests.postData(`${apiUrl}/api/user/enableuser`, {
      password,
      confirmPassword,
      code,
    });
  },
  forgotPassword: (email: string) => {
    return requests.postData(`${apiUrl}/api/user/forgotpassword`, {
      email,
    });
  },
  logout: (access_token: string, userId: string, actionType: string) => {
    return requests.getWithToken(`${apiUrl}/api/user/logout?userId=${userId}&actionType=${actionType}`,
      access_token);
  },
  resetPassword: (data: any, code) => {
    const { password, confirmPassword, email } = data;
    return requests.postData(`${apiUrl}/api/user/resetpassword`, {
      password,
      confirmPassword,
      code,
      email,
    });
  },
};

const User = {
  createUser: (access_token: string, user: Object) => {
    const {
      firstName,
      lastName,
      displayName,
      email,
      mobileNumber,
      new_user_role,
      isNotify,
    } = user;
    return requests.postWithToken(
      `${apiUrl}/api/user/create`,
      {
        firstName,
        lastName,
        displayName,
        email,
        mobileNumber,
        notifyUser: isNotify,
        roleId: [new_user_role && new_user_role.value],
        //new_user_role.map(function (item) {
        //  return item["value"];
        //}),
      },
      access_token
    );
  },
  getUserDetails: (access_token: string, userId: any) => {
    return requests.getWithToken(
      `${apiUrl}/odata/GetUserDetails?UserId=${userId}`,
      access_token
    );
  },
  sendResetPasswordEmail: (email: string) => {
    return requests.post(`${apiUrl}/api/user/forgotpassword`, { email });
  },
  changePassword: (access_token: string, data: any) => {
    return requests.postWithToken(
      `${apiUrl}/api/user/changepassword`,
      data,
      access_token
    );
  },
  updateUser: (access_token: string, data: any) => {
    data = {
      ...data,
      // roleId: [data.selected_user_role && data.selected_user_role.value],
      //data.selected_user_role.map(function (item) {
      //return item["value"];
      //}),
    };
    return requests.postWithToken(
      `${apiUrl}/api/User/UpdateUserDetails`,
      data,
      access_token
    );
  },
  updateProfile: (access_token: string, data: any) => {
    return requests.postWithToken(
      `${apiUrl}/api/user/update`,
      data,
      access_token
    );
  },
  getUsers: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/odata/GetUsers`,
      access_token
    );
  },
  getAssignableRoles: (access_token: string) => {
    return requests.getWithToken(`${apiUrl}/odata/GetRoles`, access_token);
  },
};

const PumpData = {
  getPumpFamilies: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/api/PumpSelection/GetPumpFamilies`,
      access_token
    );
  },
  getSearchDetails: (access_token, searchData, currentPage, pageSize) => {
      return requests.postWithToken(
        `${apiUrl}/odata/GetSelectedPump?$count=true&$orderby=rpm asc&$skip=${(currentPage - 1) * pageSize
        }&$top=${pageSize}`, searchData, access_token
      );
    },
  getTripleGraph: (access_token, data) => {
    return requests.postWithToken(
      `${apiUrl}/api/PumpSelection/PumpDataGraph`,      
      data, access_token
    );
  },
  getSIvalue: (access_token, data) => {
    return requests.postWithToken(
      `${apiUrl}/api/PumpSelection/TextVC`,      
      data, access_token
    );
  },
  unitValueChange: (access_token, data) => {
    return requests.postWithToken(
      `${apiUrl}/api/PumpSelection/UnitVC`,      
      data, access_token
    );
  },
  getUnitConvertor: (access_token, data) => {
    return requests.postWithToken(
      `${apiUrl}/api/UnitConverter/GetUnitValues`,   
      data, access_token
    );
  },
  getPumpReport: (access_token, data) => {
    return requests.postWithToken(
      `${apiUrl}/api/PumpSelection/GetPumpReport`,
      data, access_token
    );
  },
  getAddElements: (access_token) => {
    return requests.getWithToken(
      `${apiUrl}/api/PressureLossCalculator/AddPipeToSystem`,
      access_token
    );
  },
  getDifferentialPressureCalc: (access_token, data) => {
    return requests.postWithToken(
      `${apiUrl}/api/PressureLossCalculator/CalculateDifferentialPressure`,
      data, access_token
    );
  },
  getAddPipe: (access_token, data) => {
    return requests.postWithToken(
      `${apiUrl}/api/PressureLossCalculator/AddPipe`,
      data, access_token
    );
  },
  getPipes: (access_token, data) => {
    return requests.getWithToken(
      `${apiUrl}/odata/GetPipes?pipeSystemName=${data}`,
      access_token,
    );
  },
  consultPipe: (access_token, data) => {
    return requests.postWithToken(
      `${apiUrl}/api/PressureLossCalculator/ConsultPipe`,
      data, access_token
    );
    },
    deletePipes: (access_token, data) => {
      return requests.postWithToken(
        `${apiUrl}/api/PressureLossCalculator/DeletePipe`,
        data,access_token
      );
    },
    clearPipes: (access_token, data) => {
      return requests.getWithToken(
        `${apiUrl}/api/PressureLossCalculator/ClearAllPipesFromSystem?pipeSystemName=${data}`,
        access_token
      );
    },
    computePressureDrop: (access_token, data) => {
      return requests.postWithToken(
        `${apiUrl}/api/PressureLossCalculator/ComputePressureDrop`,
        data,
        access_token
      );
    },
    closeWindowCalc: (access_token, data) => {
      return requests.postWithToken(
        `${apiUrl}/api/PressureLossCalculator/CloseWindow`, data, access_token
      );
    },
    getSortCoordinates: (access_token, data) => {
      return requests.postWithToken(
        `${apiUrl}/api/PressureLossCalculator/SortCoordinates`,
        data, access_token
      );
    },
    getValidateGraph: (access_token, data) => {
      return requests.postWithToken(
        `${apiUrl}/api/PressureLossCalculator/ValidateGraph`,
        data, access_token
      );
    },
  };

const Maintenance = {
  getVersion: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/odata/GetVersion`,
      access_token
    );
  },
  updateVersion: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/Version/UpdateVersion`,
      data,
      access_token 
    );
  },
  getMaintFamilyList: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/odata/PumpFamilies`,
      access_token
    )
  },
  createPumpFamily: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/PumpFamily/UpdatePumpFamily`,
      {
        pumpFamilyName: data.pumpFamilyName,
        pumpFamilyDescription: data.pumpFamilyDescription
      },
      access_token
    )
  },
  updatePumpFamily: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/PumpFamily/UpdatePumpFamily`,
      data,
      access_token
    );
  },
  removePumpFamily: ( access_token: String, id: string ) => {
    return requests.getWithToken(
      `${apiUrl}/api/PumpFamily/DeletePumpFamily?id=${id}`,
      access_token
    );
  },
  getMaintPumpData: (access_token: string, id: string) => {
    return requests.getWithToken(
      `${apiUrl}/odata/PumpData?familyId=${id}`,
      access_token,
    )
  },
  createPump: (access_token: string, data: Object) => {    // When new pump is to be added
    return requests.postWithToken(
      `${apiUrl}/api/Pump/UpdatePumpData`,
       data,
      access_token
    );
  },
  updatePump: (access_token: string, data: Object) => {    // when any changes are made in pump edit page,to save that in db.  
    return requests.postWithToken(
      `${apiUrl}/api/Pump/UpdatePumpData`, 
      data,
      access_token
    );
  },
  removePump: (
    access_token: string,
    id: string
  ) => {
    return requests.getWithToken(
      `${apiUrl}/api/Pump/DeletePump?id=${id}`,
      access_token
    );
  },
  getMaintPipeMaterialList: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/odata/PipeMaterials`,
      access_token
    )
  },
  createPipeMaterial: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/PipeMaterial/UpdatePipeMaterial`,
      {
        pipeMaterialName: data.pipeMaterialName,
        pipeMaterialRoughnessCoeff: data.pipeMaterialRoughnessCoeff
      },
      access_token
    )
  },
  updatePipeMaterial: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/PipeMaterial/UpdatePipeMaterial`,
      data,
      access_token
    );
  },
  removePipeMaterial: ( access_token: String, id: string ) => {
    return requests.getWithToken(
      `${apiUrl}/api/PipeMaterial/DeletePipeMaterial?id=${id}`,
      access_token
    );
  },
  getMaintPipeElementFamilyList: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/odata/PipeElementFamilies`,
      access_token
    )
  },
  createPipeElementFamily: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/PipeElementFamily/UpdatePipeElementFamily`,
      {
        pipeElementFamilyName: data.pipeElementFamilyName,
        pipeElementFamilyRoughnessCoeff: data.pipeElementFamilyRoughnessCoeff
      },
      access_token
    )
  },
  updatePipeElementFamily: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/PipeElementFamily/UpdatePipeElementFamily`,
      data,
      access_token
    );
  },
  removePipeElementFamily: ( access_token: String, id: string ) => {
    return requests.getWithToken(
      `${apiUrl}/api/PipeElementFamily/DeletePipeElementFamily?id=${id}`,
      access_token
    );
  },
  getMaintPipeElement: (access_token: string, id: string) => {
    return requests.getWithToken(
      `${apiUrl}/odata/PipeElements?elementFamilyId=${id}`,
      access_token
    )
  },
  createPipeElement: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/PipeElement/UpdatePipeElement`,
      {
        pipeElementFamilyName: data.pipeElementFamilyName,
        pipeElementName: data.pipeElementName,
        k1coeff: data.k1coeff,
        k2coeff: data.k2coeff
      },
      access_token
    )
  },
  updatePipeElement: (access_token: string, data: Object) => {
    return requests.postWithToken(
      `${apiUrl}/api/PipeElement/UpdatePipeElement`,
      data,
      access_token
    );
  },
  removePipeElement: ( access_token: String, id: string ) => {
    return requests.getWithToken(
      `${apiUrl}/api/PipeElement/DeletePipeElement?id=${id}`,
      access_token
    );
  },
  getAccessStatus: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/api/Release/GetAccessStatus`,
      access_token,
    );
  },
  getReleaseLog: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/api/Release/GetCurrentReleaseStatus`,
      access_token,
    );
  },
  clearAccessStatus: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/api/User/ClearSelfAccStatus`,
      access_token,
    );
  },
  overrideEditing: (access_token: string) => {
    return requests.getWithToken(
      `${apiUrl}/api/User/ClearOtherAccStatus`,
      access_token,
    );
  },
  releaseDB: (access_token: string, data: string) => {
    return requests.getWithToken(
      `${apiUrl}/api/Release/Release?ReleaseComment=${data}`,
      access_token,
    );
  },
  getLockValues: (access_token: string, value: any) => {
    return requests.postWithToken(
      `${apiUrl}/api/Release/UpdateAcc`,
      value,
      access_token,
    );
  },
};

export default {
  Auth,
  User,
  PumpData,
  Maintenance
};
